window.addEventListener('load', function() {
  const heroBanner = document.querySelector('.main-hero')
  if (heroBanner !== null && heroBanner.querySelector('a.hero-banner') === null) {
    heroBanner.addEventListener( 'click' , () => {
      const gridSlider = heroBanner.nextSibling.offsetTop
      window.scrollTo( { top: gridSlider, behavior: 'smooth' })
    })
  }
})